import { Fragment, useState } from "react";
import VisibilityToggle from "src/Components/Shared/VisibilityToggle/VisibilityToggle";
import { useTranslation } from "react-i18next";
import i18n from "src/locales/i18n";

type ConfirmModalProps = {
  ConfirmationText: string;
  CancelBtnText: string;
  ConfirmBtnText: string;
  showModal: boolean;
  setModalVisibility: any;
  confirmAction: any;
  setActionStatus?: any,
  status?: any;
  memberId?: any;
};

function ConfirmModal({
  ConfirmationText,
  CancelBtnText,
  ConfirmBtnText,
  showModal,
  setModalVisibility,
  confirmAction,
  setActionStatus,
  status,
  memberId
}: ConfirmModalProps) {
  const [submitted, setSubmitted] = useState(false);
  const { t, i18n } = useTranslation();
  const handleCancel = () => {
    setActionStatus && setActionStatus("cancel");
    setModalVisibility(false);
  }

  const handleSubmit = () => {
    setActionStatus && setActionStatus(status);
    setSubmitted(true);
    memberId ? confirmAction(memberId) : confirmAction();
  }

  return (
    <Fragment>
      <div
        className={`modal fade ${showModal ? "show" : ""}`}
        id="confirm_post"
        style={{ display: showModal ? "block" : "none" }}
        role={"dialog"}
      >
        <div className="modal-dialog modal-dialog-centered modal-md">
          <div className="modal-content border-0">
            <div className="modal-body p-3 p-md-5 custom_modal">
              <div className="text-center">
                <p className="fz24 text-secondary mb-4">{t(ConfirmationText)}</p>
                <button
                  className={`btn custom_btn text-secondary bg-transparent border border-secondary ${i18n.dir() === 'rtl' ? 'ml-2':'mr-2'}`}
                  onClick={handleCancel}
                >
                  {t(CancelBtnText)}
                </button>
                <button className="btn custom_btn" onClick={handleSubmit}>
                  <VisibilityToggle visible={status === "loading" || submitted}>
                    <span className="spinner-border spinner-border-sm"></span>
                  </VisibilityToggle>
                  {t(ConfirmBtnText)}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <VisibilityToggle visible={showModal ? true : false}>
        <div
          className={`modal-backdrop fade ${showModal ? "show" : ""}`}
          onClick={handleCancel}
        ></div>
      </VisibilityToggle>
    </Fragment>
  );
}

export default ConfirmModal;
